import React from 'react'
import { Link, useLocation } from 'react-router-dom'

const toTitle = (segment: string) => {
  return segment
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (l) => l.toUpperCase())
}

const Breadcrumbs: React.FC = () => {
  const location = useLocation()
  const segments = location.pathname.split('/').filter(Boolean)
  const paths = segments.map((seg, idx) => ({
    label: toTitle(seg),
    href: '/' + segments.slice(0, idx + 1).join('/'),
  }))

  if (segments.length === 0) return null

  return (
    <nav aria-label="Breadcrumb" className="mb-4 text-sm">
      <ol className="flex items-center flex-wrap gap-1 text-gray-500">
        <li>
          <Link to="/" className="hover:text-primary-600">Ana Sayfa</Link>
        </li>
        {paths.map((p, i) => (
          <li key={p.href} className="flex items-center gap-1">
            <span className="text-gray-300">/</span>
            {i === paths.length - 1 ? (
              <span className="text-gray-700 font-medium">{p.label}</span>
            ) : (
              <Link to={p.href} className="hover:text-primary-600">{p.label}</Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default Breadcrumbs


